import React from 'react';
import PropTypes from 'prop-types';
import { Avatar } from 'shared-components/image/avatar';
import moment from 'moment/min/moment-with-locales';
import { injectIntl, intlShape } from 'react-intl';

class CommentPanel extends React.Component {
  render () {
    const { data, created, avatar_id, first_name, last_name, commentNumber, intl } = this.props;
    const locale = intl.locale;
    const timeFromNow = moment(created).locale(locale).fromNow();
    return (
      <div>
        <div className="row comment-panel-row">
          { commentNumber ? <hr /> : '' }
          <div className="col-xs-2 no-gutter-right-xs">
            <Avatar id={avatar_id} src="/web-2/assets/images/no_avatar_placeholder.svg?v=rb" />
          </div>
          <div className="col-xs-10">
            <p className="heavy" style={{ fontSize: '14px' }}>{first_name || ''} {last_name || ''}</p>
            <p style={{ whiteSpace: 'pre-wrap', overflowWrap: 'break-word' }}>{data.text}</p>
            <p className="text-gray text-small">{timeFromNow}</p>
          </div>
        </div>
      </div>
    );
  }
}

CommentPanel.propTypes = {
  data: PropTypes.object,
  avatar_id: PropTypes.string,
  created: PropTypes.string,
  first_name: PropTypes.string,
  last_name: PropTypes.string,
  commentNumber: PropTypes.number,
  intl: intlShape
};

exports.CommentPanel = injectIntl(CommentPanel);
